import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import Chat from "../components/common/Chat";
import Header from "../layout/Header";
import { useNavigate } from "react-router-dom";

function Login(){
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
        username: '',
        password: '',
    });
    const [errors, setErrors] = useState({});
    const [passwordShown, setPasswordShown] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false); // New state for submission status
    

    const togglePasswordVisibility = () => {
        setPasswordShown(!passwordShown);
    };

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const validate = () => {
        let tempErrors = {};
        const usernamePattern = /^[a-zA-Z0-9]+$/;

        if (!formData.username) tempErrors.username = "Username is required";
        else if (!usernamePattern.test(formData.username)) tempErrors.username = "Invalid username (only letters and numbers)";

        if (!formData.password) tempErrors.password = "Password is required";

        setErrors(tempErrors);
        return Object.keys(tempErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validate()) {
            setIsSubmitting(true);
            await handleLogin(formData);
            setIsSubmitting(false);
        } else {
            console.log("Form has errors. Please fix them and try again.");
        }
    };

    const [logo, setLogo] = useState([]);
    useEffect(() => {
        const fetchPromotions = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/api/logo`);
                if (!response.ok) {
                    throw new Error("Failed to fetch promotions");
                }
                const data = await response.json();
                setLogo(data[0].logo);
            } catch (error) {
                console.error("Error fetching promotions:", error);
            }
        };

        fetchPromotions();
    }, []);

    const handleLogin = async ({ username, password }) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/login`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ username, password }),
            });

            const data = await response.json();

            if (response.ok) {
                localStorage.setItem('token', data.token);
                localStorage.setItem('remote_id', data.remote_id);
                localStorage.setItem('username', data.username);
                if (data.exchange?.[0]?.token) {
                localStorage.setItem('exchangeToken', data.exchange[0].token);
                } else {
                    localStorage.removeItem('exchangeToken');
                }
                localStorage.setItem('popup', 1);
                localStorage.setItem('regPopup', 0);
                window.location.href = '/'; 
            } else {
                setErrors({ password: data.message || 'Invalid credentials' });
            }
        } catch (error) {
            console.error('Error during login:', error);
            setErrors({ password: 'Network error, please try again later.' });
        }
    };
    return (
<div className="v-application--wrap">
  <div>
    {/**/}
    <Header/>
   
  
    <div className="body">
      <div className="row no-gutters" openregisterdialog="function(){}" openlanguagedialog="function(){}">
        <div className="col col-12 login_panel">
          <div className="row hidden-md-and-up" style={{margin: 'unset'}}>
            <div className="mobile-header text-center col col-12">
              Login 
            </div>
          </div>
         
          <div className="row justify-center">
            <div className="col-md-4 col-12">
              <form noValidate="novalidate" className="v-form ma-8" onSubmit={handleSubmit}>
                <div className="row justify-center">
                  <div className="col col-12">
                    <div className="mobile">
                      <div className="row no-gutters justify-space-between">
                        <div className="col col-10">
                          <label className="input-field-label ma-0 text-capitalize d-block pb-1" style={{float: 'left'}}> Username<span className="red--text ml-1">*</span></label>
                        </div>
                        <div className="col col-2">
                          <i aria-hidden="true" aria-haspopup="true" aria-expanded="false" className="v-icon notranslate material-icons theme--dark primary--text" style={{float: 'right'}}>help</i>
                          <span className="v-tooltip v-tooltip--right">{/**/}</span>
                        </div>
                        <div className="col col-12">
                          <div className="v-input input-field elevation-0 hide-details theme--dark v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined v-text-field--placeholder">
                            <div className="v-input__control">
                              <div className="v-input__slot">
                                <fieldset aria-hidden="true">
                                  <legend style={{width: '0px'}}><span className="notranslate">​</span></legend>
                                </fieldset>
                                <div className="v-text-field__slot">
                                   <input
                                    
                                    id="input-556"
                                    placeholder="Fill up here"
                                    type="text"
                                    name="username"
                                    value={formData.username}
                                    onChange={handleChange}
                                  />
                                </div>
                              </div>
                              <div className="v-text-field__details">
                              <div className="v-messages theme--dark">
                                <div className="v-messages__wrapper">
                                  {errors.username && (
                                    <span className="red--text subtitle-2">
                                      {errors.username}
                                    </span>
                                  )}
                                </div>
                              </div>
                            </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="mobile">
                      <div className="row no-gutters justify-space-between">
                        <div className="col col-10">
                          <label className="input-field-label ma-0 text-capitalize d-block pb-1" style={{float: 'left'}}> Password<span className="red--text ml-1">*</span></label>
                        </div>
                        <div className="col col-2">
                          <i aria-hidden="true" aria-haspopup="true" aria-expanded="false" className="v-icon notranslate material-icons theme--dark primary--text" style={{float: 'right'}}>help</i>
                          <span className="v-tooltip v-tooltip--right">{/**/}</span>
                        </div>
                        <div className="col col-12">
                          <div className="v-input input-field elevation-0 hide-details theme--dark v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined v-text-field--placeholder">
                            <div className="v-input__control">
                              <div className="v-input__slot">
                                <fieldset aria-hidden="true">
                                  <legend style={{width: '0px'}}><span className="notranslate">​</span></legend>
                                </fieldset>
                                <div className="v-text-field__slot">
                                  <input
                               
                                id="input-562"
                                placeholder="Fill up here"
                                type={passwordShown ? 'text' : 'password'}
                                name="password"
                                value={formData.password}
                                onChange={handleChange}
                              />
                                </div>
                                <div className="v-input__append-inner">
                                <button
                                  type="button"
                                  onClick={togglePasswordVisibility}
                                  className={`v-icon notranslate v-icon--link mdi ${
                                    passwordShown ? 'mdi-eye-off' : 'mdi-eye'
                                  } theme--dark`}
                                />
                              </div>
                              </div>
                              <div className="v-text-field__details">
                              <div className="v-messages theme--dark">
                                <div className="v-messages__wrapper">
                                  {errors.password && (
                                    <span className="red--text subtitle-2">
                                      {errors.password}
                                    </span>
                                  )}
                                </div>
                              </div>
                            </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                   
                    {/* <div className="row mb-1 no-gutters">
                      <div className="col col-12 text-right forgot-password">
                        <button type="button" className="text-capitalize body-3 text-decoration-underline v-btn v-btn--text theme--dark v-size--default pr-0 title_color2--text font-weight-bold" style={{height: 'auto'}}>
                          <span className="v-btn__content">
                            Forgot password
                          </span>
                        </button>
                      </div>
                    </div> */}
                    <div className="row hidden-md-and-up no-gutters">
                      <div className="col col-12">
                        <button  type="submit"
            disabled={isSubmitting}  className="primary-button theme-button text-capitalize pa-2 font-weight-bold yellow--text v-btn v-btn--has-bg theme--dark v-size--default black mobile-login-btn" style={{height: 'auto'}}>
                          <span className="v-btn__content">
                           {isSubmitting ? 'Logging in...' : 'Login'}
                          </span>
                        </button>
                      </div>
                      <div className="text-center col col-12"><label className="red--text subtitle-2" style={{display: 'none'}} /><label className="red--text subtitle-2" style={{display: 'none'}} /></div>
                    </div>
                   
                    <div className="row no-gutters py-6">
                      <div className="col col-12"><hr role="separator" aria-orientation="horizontal" className="v-divider theme--dark dialog-divider" /></div>
                    </div>
                    <div className="row hidden-md-and-up no-gutters">
                      <div className="col col-12">
                        <label className="input-field-label ma-0 pb-1 d-block title_color2--text">
                          Don't have an account yet?
                        </label>
                      </div>
                    </div>
                    <div className="row pb-10 hidden-md-and-up no-gutters">
                      <div className="col col-12">
                        <button  onClick={() => navigate("/signup")} data-v-1dea3caa type="button" className="full-width font-weight-bold pa-2 dialog-button v-btn v-btn--is-elevated v-btn--has-bg theme--dark v-size--default buttonPrimary theme-button theme--dark subtitle-1">
                          <span className="v-btn__content">Sign Up </span>
                        </button>
                      </div>
                    </div>
                   
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    
   <Chat/>
  </div>
</div>

    );
}
export default Login;